import {FC, useState} from 'react'
import {bookingFlows, campaigns, windowRepairImage} from "../constants/global";
import {serviceName, servicePriceString} from "../lib/booking";
import {get_active_sidebar_campaigns} from "../wordpress/operations/get-offers";
import Remove from "./Options/Remove";
import {formatNumber} from "../lib/helpers";
import Footer from "./Footer";
import NavNextPrev from "./common/NavNextPrev/NavNextPrev";

interface Props {
    booking: Booking
    workshops: any,
    setBooking: Function,
    content: Content
}

const Sidebar: FC<Props> = ({ booking, workshops, setBooking, content }) => {
    const sidebarItemActive = {
        car:booking.car.reg,
        service:booking.serviceArray.length > 0,
        insurance:booking.car.insurance && booking.booking_flow === 'window' && booking.window.form.window_damage_type,
        workshop:booking.workshop,
        date:booking.date,
        options:booking.options.length > 0 || booking.hjulskifte.options.product_id || booking.tire_shop.length > 0 || booking.loan_car === 'yes' || booking.loan_car_mercedes || booking.loan_car_opel,
        submission:booking.submission.slug,
        total:false
    }

    const [sidebarItemOpen, setSidebarItemOpen] = useState({car:true, service:true, insurance:true, workshop:true, date:true, options:true, submission:true, total:true});

    const debug_booking = <pre>{JSON.stringify(booking, null, 2)}</pre>;
    const debug_window_image = <pre>{JSON.stringify(windowRepairImage, null, 2)}</pre>;
    const debug_flow = <pre>{JSON.stringify(bookingFlows[booking.booking_flow], null, 2)}</pre>;

    // Add items
    const car = []
    booking.car.reg !=='' && car.push({name:'Regnr', value:booking.car.reg})
    booking.car.brand !== '' && car.push({name:'Märke', value:booking.car.brand})
    booking.car.model !== '' && car.push({name:'Modell', value:booking.car.model})
    booking.car.year !== '' && car.push({name:'Årsmodell', value:booking.car.year})
    booking.car.mileage > 0 && car.push({name:'Miltal', value:booking.car.mileage.toString()})
    booking.car.color !== null && car.push({name:'Färg', value:booking.car.color})

    // Service (tjänst) rows
    const service = []
    for(let i=0; i<booking.serviceArray.length; i++){
        const _service = booking.serviceArray[i]
        let name = serviceName(booking, _service)


        if((_service.slug === 'glas' || _service.slug === 'bilglas') && booking.window.form.window_damage_type === 'chip') {
            name += ': \nLaga stenskott x ' + booking.window.form.chip_counter
            //service.push({name:'Laga stenskott', value:'Pris offereras på mail efter bokning'})
        }
        if((_service.slug === 'glas' || _service.slug === 'bilglas') && booking.window.form.window_damage_type === 'crack') {
            name += ': \nByta vindruta'
            //service.push({name:'Byta vindryta', value:'Pris offereras på mail efter bokning'})
        }

        service.push({name:name, value:servicePriceString(booking, _service)})
    }

    const active_service_campaigns:any = get_active_sidebar_campaigns(booking, campaigns.offers)


    // Workshop (verkstad) rows
    const workshop = workshops[booking.workshop]
    const date = []
    booking.date !== '' && date.push({name:'', value:booking.date})

    // Options and price (tillval, summa) rows
    let price = 0
    for(let i=0; i<booking.options.length; i++){
        const _option = booking.options[i]
        if(_option.is_price_visible) {
            _option.price_string = formatNumber(parseInt(_option.price)) + ' kr'
            _option.org_price_string = ''
            if(_option.is_on_sale) {
                _option.price_string = formatNumber(parseInt(_option.sale_price)) + ' kr'
                _option.org_price_string = formatNumber(parseInt(_option.price)) + ' kr'
                price += parseInt(_option.sale_price)
            }else{
                price += parseInt(_option.price)
            }
        }
    }

    for(let i=0; i<booking.tire_shop.length; i++){
        if(booking.tire_shop[i])
            price += booking.tire_shop[i].price
    }

    if(booking.hjulskifte.options.product_id && booking.hjulskifte.options.price) {
        price += booking.hjulskifte.options.price
    }

    if(booking.loan_car === 'yes')
        price += booking.loan_car_price

    if(price > 0)
        sidebarItemActive.total = true




    const handleClick = (type:string) => {
        switch (type) {
            case 'car':
                setSidebarItemOpen ({...sidebarItemOpen, car : !sidebarItemOpen.car})
                break
            case 'service':
                setSidebarItemOpen ({...sidebarItemOpen, service : !sidebarItemOpen.service})
                break
            case 'insurance':
                setSidebarItemOpen ({...sidebarItemOpen, insurance : !sidebarItemOpen.insurance})
                break
            case 'workshop':
                setSidebarItemOpen ({...sidebarItemOpen, workshop : !sidebarItemOpen.workshop})
                break
            case 'date':
                setSidebarItemOpen ({...sidebarItemOpen, date : !sidebarItemOpen.date})
                break
            case 'options':
                setSidebarItemOpen ({...sidebarItemOpen, options : !sidebarItemOpen.options})
                break
            case 'submission':
                setSidebarItemOpen ({...sidebarItemOpen, submission : !sidebarItemOpen.submission})
                break
            case 'total':
                setSidebarItemOpen ({...sidebarItemOpen, total : !sidebarItemOpen.total})
                break
        }
    }

    return (
        <div id="booking-sidebar" className="booking-sidebar">
            <div className="right-side-content">
                <div>
                    <div
                        className={'booking-sidebar_section' + (sidebarItemOpen.car ? (' open') : ('')) + (sidebarItemActive.car ? (' active') : (''))}>
                        <div className={'booking-sidebar_header'} onClick={() => handleClick('car')}>Min bokning</div>
                        {car.map((item: any, i: number) => (
                            <div key={i} className={'booking-sidebar_item flex'}>
                                <span>{item.name}</span><span>{item.value}</span></div>
                        ))}
                    </div>
                    <div
                        className={'booking-sidebar_section' + (sidebarItemOpen.service ? (' open') : ('')) + (sidebarItemActive.service ? (' active') : (''))}>
                        <div className={'booking-sidebar_sub'} onClick={() => handleClick('service')}>Tjänst</div>
                        {service.map((item: any, i: number) => (
                            <div key={i} className={'booking-sidebar_item flex'}><span
                                style={{whiteSpace: "pre-line"}}>{item.name}</span>
                                {item.value != 'insurance' ? (
                                    <span
                                        className={"price"}>{item.value} {item.value != 'Pris offereras på mail efter bokning' && 'kr'}</span>
                                ) : (
                                    <span className={"price"}>Försäkring</span>
                                )}
                            </div>
                        ))}
                        {active_service_campaigns.map((item: any, i: number) => (
                            <div key={i} className={'booking-sidebar_item flex'}><span>{item}</span></div>
                        ))}
                    </div>
                    <div
                        className={'booking-sidebar_section' + (sidebarItemOpen.insurance ? (' open') : ('')) + (sidebarItemActive.insurance ? (' active') : (''))}>
                        <div className={'booking-sidebar_sub'} onClick={() => handleClick('service')}>Försäkring</div>
                        {booking.car.insurance && (
                            <div className={'booking-sidebar_item flex'} style={{paddingBottom: '0'}}><span
                                style={{fontWeight: 400}}>{booking.car.insurance.insurance_company}</span></div>
                        )}
                        {booking.car.insurance && booking.window.form.window_damage_type === 'crack' && (
                            <div className={'booking-sidebar_item flex'} style={{paddingTop: '0'}}>Uppskattat pris/självrisk: <span
                                className={"price"}>{booking.car.insurance.cost.window_change ? booking.car.insurance.cost.window_change + ' kr' : 'Uppgift saknas'}</span>
                            </div>
                        )}
                        {booking.car.insurance && booking.window.form.window_damage_type === 'chip' && (
                            <div className={'booking-sidebar_item flex'} style={{paddingTop: '0'}}>Uppskattat pris/självrisk: <span
                                className={"price"}>{booking.car.insurance.cost.chip_repair ? booking.car.insurance.cost.chip_repair + ' kr' : 'Uppgift saknas'}</span>
                            </div>
                        )}

                    </div>
                    <div
                        className={'booking-sidebar_section' + (sidebarItemOpen.workshop ? (' open') : ('')) + (sidebarItemActive.workshop ? (' active') : (''))}>
                    <div className={'booking-sidebar_sub'} onClick={() => handleClick('workshop')}>Verkstad</div>
                        {workshop && (
                            <div className={'booking-sidebar_item'}>
                                <div style={{fontWeight: 400}}>{workshop.title}</div>
                                <span className={'booking-sidebar_text'}>{workshop.address}</span>
                            </div>
                        )}
                    </div>
                    <div
                        className={'booking-sidebar_section' + (sidebarItemOpen.date ? (' open') : ('')) + (sidebarItemActive.date ? (' active') : (''))}>
                        <div className={'booking-sidebar_sub'} onClick={() => handleClick('date')}>Datum</div>
                        {date.map((item: any, i: number) => (
                            <div key={i} className={'booking-sidebar_item flex'}>
                                <span>{item.name}</span><span>{item.value}</span></div>
                        ))}
                    </div>
                    <div
                        className={'booking-sidebar_section' + (sidebarItemOpen.submission ? (' open') : ('')) + (sidebarItemActive.submission ? (' active') : (''))}>
                        <div className={'booking-sidebar_sub'} onClick={() => handleClick('submission')}>In- och
                            utlämning
                        </div>
                        {booking.submission.name && (
                            <div className={'booking-sidebar_item flex'}>
                                <span>{booking.submission.name}</span>
                                {booking.submission.type.includes("time") && (
                                    <span>{booking.submission.time}</span>
                                )}
                            </div>
                        )}

                        {booking.submission.type.includes("address") && (
                            <div className={'booking-sidebar_item flex'}>
                                <span>
                                    {booking.submission.address}<br/>
                                    {booking.submission.postal} {booking.submission.city}
                                </span>
                            </div>
                        )}
                    </div>
                    <div
                        className={'booking-sidebar_section' + (sidebarItemOpen.options ? (' open') : ('')) + (sidebarItemActive.options ? (' active') : (''))}>
                        <div className={'booking-sidebar_sub'} onClick={() => handleClick('options')}>Tillval</div>
                        {booking.loan_car === 'yes' && (
                            <div className={'booking-sidebar_item flex'}>
                                <span className={'option-name'}>Lånebil</span>
                                <span style={{whiteSpace: "nowrap"}}>{booking.loan_car_price} kr/dygn</span>
                            </div>
                        )}

                        {booking.loan_car_opel && (
                            <div className={'booking-sidebar_item flex'}>
                                <span className={'option-name'}>Hyrbil</span>
                                <span style={{whiteSpace: "nowrap"}}></span>
                            </div>
                        )}

                        {booking.loan_car_mercedes && (
                            <div className={'booking-sidebar_item flex'}>
                                <span className={'option-name'}>Hyrbil</span>
                                <span style={{whiteSpace: "nowrap"}}></span>
                            </div>
                        )}

                        {booking.hjulskifte.options.product_id && (
                            <div className={'booking-sidebar_item flex'}>
                                <span className={'option-name'}><Remove booking={booking} setBooking={setBooking}
                                                                        item={booking.hjulskifte.options}/>{booking.hjulskifte.options.name}</span>
                                <span
                                    style={{whiteSpace: "nowrap"}}>{formatNumber(booking.hjulskifte.options.price)} kr</span>
                            </div>
                        )}
                        {booking.tire_shop.map((item: any, i: number) => (
                            <div key={i} className={'booking-sidebar_item flex'}>
                                <span className={'option-name'}><Remove booking={booking} setBooking={setBooking}
                                                                        item={item}/>{item.name}</span>
                                <span style={{whiteSpace: "nowrap"}}>{formatNumber(item.price)} kr</span>
                            </div>
                        ))}
                        {booking.options.map((item: any, i: number) => (
                            <div key={i} className={'booking-sidebar_item flex'}>
                                <span className={'option-name'}><Remove booking={booking} setBooking={setBooking}
                                                                        item={item}/>{item.name}</span>
                                <span className={"price"}><del>{item.org_price_string}</del>&nbsp;
                                    {item.price_string ? item.price_string : 'Pris offereras på mail efter bokning'}</span>
                            </div>
                        ))}
                    </div>
                    <div
                        className={'booking-sidebar_section' + (sidebarItemOpen.total ? (' open') : ('')) + (sidebarItemActive.total ? (' active') : (''))}>
                        <div className={'booking-sidebar_sub'} onClick={() => handleClick('total')}>Summa</div>
                        {price > 0 && (
                            <div className={'booking-sidebar_item flex'}><span className={'sidebar-desc'}>Priset avser tillvalen exklusive eventuella extrarabatter.</span><span
                                className={'nowrap'}>{formatNumber(price)}&nbsp;kr</span></div>
                        )}
                    </div>
                </div>
            </div>
            {booking.debug && (
                <>
                    <div>
                        <h2>Booking info</h2>
                        {debug_booking}
                    </div>
                    <div>
                        <h2>Active booking flow</h2>
                        {debug_flow}
                    </div>
                    <div>
                        <h2>Window repair image</h2>
                        {debug_window_image}
                    </div>
                </>
            )}
        </div>
    )
}

export default Sidebar
